module.exports = __webpack_public_path__ + "img/mygate.4e35aa60.svg";